module.exports = __webpack_public_path__ + "img/FR41249.6520caa1.png";